import { useComponentTranslation } from '@tebuto/functions/translation.components'
import ConfirmationDialogue from '@tebuto/modals/ConfirmationDialogue'
import MediumText from '@tebuto/typography/MediumText'
import { useContext } from 'react'
import { BookingContext } from './context'

export default function EventAlreadyBookedDialog() {
    const { t } = useComponentTranslation()
    const {
        isEventAlreadyBookedDialogOpen,
        setIsEventAlreadyBookedDialogOpen,
        setNavigationDirection,
        setState,
        refreshEvents
    } = useContext(BookingContext)
    return (
        <ConfirmationDialogue
            open={isEventAlreadyBookedDialogOpen}
            setOpen={setIsEventAlreadyBookedDialogOpen}
            title={t('booking.eventAlreadyBookedDialog.title')}
            submitButtonText={t('booking.backToCalendar')}
            onSubmit={() => {
                refreshEvents()
                setState('calendar')
                setNavigationDirection('back')
            }}
        >
            <div className="widget-already-booked-container">
                <MediumText>{t('booking.eventAlreadyBookedDialog.description1')}</MediumText>
                <MediumText>{t('booking.eventAlreadyBookedDialog.description2')}</MediumText>
            </div>
        </ConfirmationDialogue>
    )
}
